import '../navbars/nav-items/NavItems.scss';
import { Dropdown, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { useAppSelector, useAppDispatch } from 'redux/store';
import { AppLanguage, SUPPORTED_LANGUAGES, selectAppLanguage } from 'redux/selectors/userSettings';

import { setUserSetting, updateUser } from '../../redux/slices/auth';

// Keyed by AppLanguage, so a language added to SUPPORTED_LANGUAGES does not
// compile until it has a name and a flag here.
const LANGUAGES: Record<AppLanguage, { name: string; flag: string }> = {
  en: { name: 'English', flag: 'https://flagcdn.com/w20/gb.png' }, // UK Flag
  nl: { name: 'Nederlands', flag: 'https://flagcdn.com/w20/nl.png' }, // Netherlands Flag
};

// Self-contained picker for the UI language. Owns the read (selector) and the
// write (optimistic setUserSetting + persisted updateUser), like the other
// user-preference controls. It does not call i18n.changeLanguage: applying the
// preference is useApplyAppLanguage's job, and a second writer is what made
// the selector unswitchable (#1166).
const LanguageSwitcher = () => {
  const dispatch = useAppDispatch();

  const language = useAppSelector(selectAppLanguage);
  const user_settings = useAppSelector((state) => state.auth.userData?.user_settings ?? {});

  const pickLanguage = (lng: AppLanguage) => {
    if (lng === language) return;
    dispatch(setUserSetting({ key: 'appLanguage', value: lng }));
    dispatch(updateUser({ user_settings: { ...user_settings, appLanguage: lng } }));
  };

  const currentLanguage = LANGUAGES[language];

  return (
    <Dropdown>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="lang-tooltip" style={{ position: 'fixed' }}>
            Language
          </Tooltip>
        }
      >
        <Dropdown.Toggle as="div" id="dropdown-basic" className="dropdown-caret-none" style={{ cursor: 'pointer' }}>
          <div className="nav-icon-circle nav-icon-circle--blue">
            <Image src={currentLanguage.flag} alt={currentLanguage.name} style={{ width: '18px' }} />
          </div>
        </Dropdown.Toggle>
      </OverlayTrigger>

      <Dropdown.Menu>
        {SUPPORTED_LANGUAGES.map((code) => (
          <Dropdown.Item key={code} onClick={() => pickLanguage(code)}>
            <Image src={LANGUAGES[code].flag} alt={LANGUAGES[code].name} style={{ width: '20px', marginRight: '5px' }} />
            {LANGUAGES[code].name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
